/**
 * @param {Address} a
 * @return {string}
 */
export default function oneLineAddress(a) {
  const address1And2 = [a.address1, a.address2].join(" ").trim();
  const lines = [address1And2, a.city, a.stateOrProvince, a.postalCode].filter(
    Boolean
  );
  return lines.join(", ");
}
